import React from 'react'
import ServiceLayout from '../components/ServiceLayout'
import { ArrowRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import ServiceCTA from '../components/ServiceCTA'

const DrugDiscoveryPage = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const subpagesData = t('aiMlOverview.drugDiscovery.subpages', { returnObjects: true })
    const paths = [
        '/service/ai-ml/target-identification',
        '/service/ai-ml/hit-discovery',
        '/service/ai-ml/lead-optimization',
        '/service/ai-ml/preclinical-biomarker',
        '/service/ai-ml/translational-pkpd'
    ]

    const subpages = Array.isArray(subpagesData) ? subpagesData.map((data, i) => ({
        ...data,
        path: paths[i]
    })) : []

    return (
        <ServiceLayout
            breadcrumbs={[
                { label: t('header.home'), path: '/' },
                { label: t('header.service'), path: '/service' },
                { label: t('aiMlOverview.title'), path: '/service/ai-ml' },
                { label: t('aiMlOverview.drugDiscovery.title') }
            ]}
            title={t('aiMlOverview.drugDiscovery.title')}
            subtitle={t('aiMlOverview.drugDiscovery.subtitle')}
        >
            <div className="space-y-4">
                {subpages.map((page, i) => (
                    <button
                        key={i}
                        onClick={() => navigate(page.path)}
                        className="group flex items-center justify-between p-5 bio-card-static rounded-xl border border-border-light hover:border-primary/30 hover:bg-primary-50 transition-all text-left w-full"
                    >
                        <div>
                            <h3 className="font-bold text-sm mb-1">{page.title}</h3>
                            <p className="text-text-muted text-xs">{page.desc}</p>
                        </div>
                        <ArrowRight className="w-4 h-4 text-text-muted group-hover:text-primary transition-colors flex-shrink-0 ml-4" />
                    </button>
                ))}
            </div>
            <ServiceCTA />
        </ServiceLayout>
    )
}

export default DrugDiscoveryPage
